"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortingContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const layout_1 = require("../../layout");
const SortingContainer = ({ children }) => {
    const elements = Array.isArray(children) ? children : [children];
    return ((0, jsx_runtime_1.jsxs)(layout_1.Stack, { space: 2, direction: 'row', center: true, children: [(0, jsx_runtime_1.jsx)(layout_1.LayoutElement, { children: (0, jsx_runtime_1.jsx)("span", { className: "text-nowrap", children: "Se\u0159adit podle:" }) }), elements.map(element => ((0, jsx_runtime_1.jsx)(layout_1.LayoutElement, { children: element })))] }));
};
exports.SortingContainer = SortingContainer;
